module.exports = __webpack_public_path__ + "img/clean-eating.86a8d12d.png";